<script>
import { escapeMixin } from "../mixins/escapeMixin.js";
import { languageMixin } from "../mixins/languageMixin.js";
import { requestMixin } from "../mixins/requestMixin.js";

import ParamInputText from "./ParamInputText.vue";
import ParamInputFile from "./ParamInputFile.vue";
import LanguagePicker from "./LanguagePicker.vue";
import CodeParam from "./CodeParam.vue";

import { codeHighlightHtmlString } from "../js/highlight.js";

export default {
  name: "CodeExample",
  components: {
    "param-input-text": ParamInputText,
    "param-input-file": ParamInputFile,
    "code-param": CodeParam,
    "language-picker": LanguagePicker,
  },
  mixins: [escapeMixin, requestMixin, languageMixin],
  props: ["files", "params", "method", "requestUrl", "urlParams"],
  data: function () {
    return {};
  },
  methods: {
    showGroup: function (arr) {
      if (!arr) return false;
      return arr.some((element) => element.showElement);
    },
    filterGroup: function (arr) {
      if (!arr) return [];
      return arr.filter((element) => element.showElement);
    },
  },
  computed: {
    filteredFiles: function () {
      var files = this.urlParams.filter((param) => param.type === "File");
      return this.filterGroup(files);
    },
    filteredParams: function () {
      var params = this.urlParams.filter((param) => param.type !== "File");
      return this.filterGroup(params);
    },
  },
  created: function () {
    var methodSpecs = {
      apiUrl: this.userUrlBase + this.requestUrl,
      method: this.method,
    };
    var template = "";
    template += `<div class="example-and-response">`;
    template += `<div class="code-example">`;
    template += `<div class="code-header"><span class="code-example-title"><slot></slot></span><language-picker :value="language" @input="$emit('language-change', $event)" /></div>`;
    template += `<div class="code-body">`;
    template += `<pre v-show="isLanguage('python')" class="language-py"><code>${generatePythonRequest(
      methodSpecs,
    )}</code></pre>`;
    template += `<pre v-show="isLanguage('shell')" class="language-shell"><code>${generateShellRequest(
      methodSpecs,
    )}</code></pre>`;
    template += `<pre v-show="isLanguage('node')" class="language-js"><code>${generateNodeRequest(
      methodSpecs,
    )}</code></pre>`;
    template += `<pre v-show="isLanguage('ruby')" class="language-ruby"><code>${generateRubyRequest(
      methodSpecs,
    )}</code></pre>`;
    template += `<hr /><button type="button" v-on:click="runRequest">Run</button>`;
    template += `</div>`;
    template += `</div><div class="response"><pre><code>{{response}}</code></pre>`;
    template += `</div></div>`;
    this.$options.template = codeHighlightHtmlString(template);
  },
};

function generateRubyRequest(callDef) {
  var code = `require 'rest-client'\n\n`;
  code += `request = RestClient::Request.new(\n`;

  if (callDef.method === "post") {
    var payload = `          :payload => {\n`;
    payload += `            :multipart => true,`;

    payload += '<div v-show="filteredFiles.length">';
    payload += `<code-param v-for="(file, index) in filteredFiles" :key="'ruby-'+file.varName" :data="file" v-slot="param"><span v-show="index">,\n</span>            <span class="highlight">:{{file.varName}}</span> => File.new('<span class="highlight">{{param.value}}</span>', 'rb')</code-param>`;
    payload += '<span v-show="filteredParams.length">,</span>';
    payload += "</div>";

    payload += '<div v-show="filteredParams.length">';
    payload += "            :data => {";
    payload += `<code-param v-for='(foo, index) in filteredParams' :key="'ruby-'+foo.varName" :data="foo" v-slot="param" v-bind="foo.type === String ? {escape: escapePyString}:{}"><span v-show="index">,</span>\n              <span class="highlight">:{{foo.varName}} => {{param.value}}</span></code-param>`;
    payload += `\n            }.to_json\n`;
    payload += "}</div>";

    code += `          :method => :post,\n`;
    code += `          :url => '${callDef.apiUrl}',\n`;
    code += `          :user => '{{username}}',\n`;
    code += `          :password => '{{password}}',\n`;
    code += payload;
    code += `          )\n`;
  } else {
    var params = '<div v-show="filteredParams.length">';
    params += `          :params => {`;

    params += `<code-param v-for='(foo, index) in filteredParams' :key="'ruby-'+foo.varName" :data="foo" v-slot="param" v-bind="foo.type === String ? {escape: escapePyString}:{}"><span v-show="index">,</span>\n              <span class="highlight">:{{foo.varName}} => {{param.value}}</span></code-param>`;
    params += "}</div>";

    code += `          :method => :get,\n`;
    code += `          :url => '${callDef.apiUrl}',\n`;
    code += `          :user => '{{username}}',\n`;
    code += `          :password => '{{password}}',\n`;
    code += params;
    code += `          )\n`;
  }

  code += `response = request.execute`;

  return code;
}

// function generatePhpRequest(callDef) {
//     var code = `&lt;?php\n\n`

//     code += `use GuzzleHttp\\Client;\n\n`

//     code += `const USER = {{username}}\n`
//     code += `const PASSWORD = {{password}}\n\n`

//     return code
// }

function generateShellRequest(callDef) {
  var code = `curl "${callDef.apiUrl}" \\\n`;
  code += `    --user {{username}}:{{password}}`;
  var dataParam = "";
  var filesParam = "";

  if (callDef.method === "post") {
    filesParam += '<span v-show="filteredFiles.length">';
    filesParam += `<code-param v-for="(file, index) in filteredFiles" :key="'shell-'+file.varName" :data="file" v-slot="param"> \\\n    -F "<span class="highlight">{{file.varName}}=@{{param.value}}</span>"</code-param>`;
    filesParam += "</span>";
  } else {
    code += ` --get`;
  }

  dataParam += '<span v-show="filteredParams.length">';
  dataParam += `<code-param v-for='(foo, index) in filteredParams' :key="'shell-'+foo.varName" :data="foo" v-slot="param"> \\\n    -F "<span class="highlight">{{foo.varName}}={{param.value}}</span>"</code-param>`;
  dataParam += "</span>";

  code += filesParam;
  code += dataParam;
  return code;
}

function generateNodeRequest(callDef) {
  var code = `var request = require("request");\n\n`;
  var dataParam = "";
  var filesParam = "";

  if (callDef.method === "post") {
    code += `var fs = require("fs");\n\n`;

    filesParam += '<div v-show="filteredFiles.length">';
    filesParam += "const formData = {";
    filesParam += `<code-param v-for="(file, index) in filteredFiles" :key="'node-'+file.varName" :data="file" v-slot="param" :escape="escapePyString"><span v-show="index">,</span>\n    <span class="highlight">'{{file.varName}}'</span>: fs.createReadStream(<span class="highlight">{{param.value}}</span>)</code-param>`;
    filesParam += "\n};\n\n";
    filesParam += "</div>";
  }
  code += `const auth = {\n    'user': '{{username}}',\n    'pass': '{{password}}'\n};\n\n`;

  dataParam += '<div v-show="filteredParams.length">';
  dataParam += "const data = {";
  dataParam += `<code-param v-for='(foo, index) in filteredParams' :key="'node-'+foo.varName" :data="foo" v-slot="param" v-bind="foo.type === String ? {escape: escapePyString}:{}"><span v-show="index">,</span>\n    <span class="highlight">'{{foo.varName}}': {{param.value}}</span></code-param>`;
  dataParam += "\n};\n\n";
  dataParam += "</div>";

  code += dataParam;
  code += filesParam;

  code += `var options = {\n`;
  code += `    'method': '${callDef.method.toUpperCase()}',\n`;
  code += `    'url': '${callDef.apiUrl}',\n`;
  code += `    'auth': auth,\n`;
  code += `<span v-show="filteredParams.length">    'qs': data,\n</span>`;
  code += `<span v-show="filteredFiles.length">    'formData': formData,\n</span>`;
  code += `};\n\n`;

  code += `request(options, function (error, response, body) {\n`;
  code += `  if (error) throw new Error(error);\n`;
  code += `  console.log(body);\n`;
  code += `});`;
  return code;
}

function generatePythonRequest(callDef) {
  var code = "import requests\nfrom requests.auth import HTTPBasicAuth\n\n";
  var dataParam = "";

  code += `api_url = '${callDef.apiUrl}'\n`;
  code += `user = '{{username}}'\n`;
  code += `password = '{{password}}'\n`;
  code += `auth = HTTPBasicAuth(user, password)\n`;

  if (callDef.method === "post") {
    var filesParam = "";

    filesParam += '<div v-show="filteredFiles.length">';
    filesParam += "files = {";
    filesParam += `<code-param v-for="(file, index) in filteredFiles" :key="'python-'+ file.varName" :data="file" v-slot="param" :escape="escapePyString"><span v-show="index">,</span>\n    <span class="highlight">'{{file.varName}}'</span>: open(<span class="highlight">{{ param.value }}</span>, 'rb')</code-param>`;
    filesParam += "\n}\n\n";
    filesParam += "</div>";

    dataParam += '<div v-show="filteredParams.length">';
    dataParam += "data = {";
    dataParam += `<code-param v-for='(foo, index) in filteredParams' :key="'python-'+ foo.varName" :data="foo" v-slot="param" v-bind="foo.type === String ? {escape: escapePyString}:{}"><span v-show="index">,</span>\n    <span class="highlight">'{{foo.varName}}': {{param.value}}</span></code-param>`;
    dataParam += "\n}\n\n";
    dataParam += "</div>";

    code += filesParam;
    code += dataParam;
    code += `response = requests.post(api_url, auth=auth`;
    code += '<span v-show="filteredFiles.length">, files=files</span>';
    code += '<span v-show="filteredParams.length">, data=data</span>';
    code += ")";
    return code;
  }

  dataParam += '<div v-show="filteredParams.length">';
  dataParam += "params = {";
  dataParam += `<code-param v-for='(foo, index) in filteredParams' :key="'python-'+foo.varName" :data="foo" v-slot="param" :escape="escapePyString"><span v-show="index">,</span>\n    <span class="highlight">'{{foo.varName}}': {{param.value}}</span></code-param>`;
  dataParam += "\n}\n\n";
  dataParam += "</div>";

  code += dataParam;
  code += `response = requests.get(api_url, auth=auth`;
  code += '<span v-show="filteredParams.length">, params=params</span>';
  code += ")";
  return code;
}
</script>

<style lang="less">
@import (reference) "~@/assets/less/site.less";

@media (min-width: @screen-md-min) {
  .example-and-response {
    margin: 24px -80px;
  }
}

.code-header {
  // margin-left: -40px;
  // margin-right: -40px;
  padding-left: 16px;
  padding-right: 16px;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
  background-color: #28313a;
  color: @extra-light-text;
  a {
    float: left;
    .small-text();
    color: @extra-light-text;
    text-align: center;
    padding: 14px 8px;
    margin: 0px 16px;
    text-decoration: none;

    &.active {
      color: white;
      border-bottom: 2px solid white;
      font-weight: @bold;
    }
  }
  span.code-example-title {
    float: left;
    .small-text();
    color: white;
    text-align: center;
    padding: 14px 8px;
    margin: 0px 16px;
    text-decoration: none;
    font-weight: @bold;
  }

  .languages-menu {
    float: right;
  }
}

.code-example {
  background-color: @default-text;
  pre {
    background-color: inherit;
    padding: 0 0 24px;
  }
  // padding: 0px 40px 24px;
  .code-body {
    padding: 0px 40px 24px;
  }
  margin-bottom: 18px;
  border-radius: 4px;
  button {
    .secondary-btn();
    background-color: @medium-text;
    border-radius: 3px;
  }
  hr {
    border-top: 1px solid @medium-text;
  }
}

.code-widget-error label {
  color: red;
}

code .code-widget-error .highlight,
code .code-widget-error.highlight {
  color: #000000;
  & span.token {
    color: #000000;
  }
  background-color: #ed5252;
  text-shadow: none;
}

code .focus .highlight,
code .focus.highlight {
  color: inherit;
  & span.token {
    color: inherit;
  }
  background-color: #80808080;
}
</style>
